// extracted by mini-css-extract-plugin
module.exports = {"card":"OTPPopup_card__1PmW3","tpin":"OTPPopup_tpin__3y-FL","buttonWrapper":"OTPPopup_buttonWrapper__1ODyz"};